module.exports = __webpack_public_path__ + "files/5f6496eceda1e652218ee3d678d17ad0.png";